module.exports = __webpack_public_path__ + "public/images/icons/paks.93c9b1587eb485a6f139c809e26ceeb3.svg";